module App {
    //declare var moment: any;

    export class KendoFilterTranslation {
        Contains: string;
        StartsWith: string;
        DoesNotContain: string;
        Eq: string;
        DateLe: string;
        DateGe: string;
        Gt: string;
        Lt: string;
        Neq: string;
    }

    export class LocaleService {
        public static Factory($q: ng.IQService,
            $translate: angular.translate.ITranslateService,
            $translatePartialLoader: any,
            $state: angular.ui.IStateService,
            tmhDynamicLocale: any,
            $cookies: angular.cookies.ICookiesService) {
            return new LocaleService($q, $translate, $translatePartialLoader, $state, tmhDynamicLocale, $cookies);
        }

        constructor(
            private $q: ng.IQService,
            private $translate: angular.translate.ITranslateService,
            private $translatePartialLoader: any,
            private $state: angular.ui.IStateService,
            private tmhDynamicLocale: any,
            private $cookies: angular.cookies.ICookiesService) {

        }

        // PROPS
        private kendoFilterTranslation: KendoFilterTranslation;

        // PUBLIC
        getKendoFilterTranslationObject() {
            return {
                string: {
                    contains: this.kendoFilterTranslation.Contains,
                    startswith: this.kendoFilterTranslation.StartsWith,
                    doesnotcontain: this.kendoFilterTranslation.DoesNotContain,
                },
                date: {
                    eq: this.kendoFilterTranslation.Eq,
                    le: this.kendoFilterTranslation.DateLe,
                    ge: this.kendoFilterTranslation.DateGe,
                },
                number: {
                    gt: this.kendoFilterTranslation.Gt,
                    lt: this.kendoFilterTranslation.Lt,
                    eq: this.kendoFilterTranslation.Eq
                },
                enums: {
                    eq: this.kendoFilterTranslation.Eq,
                    neq: this.kendoFilterTranslation.Neq,
                }
            }

        }

        getLocale(): string {
            return this.$translate.proposedLanguage();
        }

        setLocale(locale: string): void {
            this.$translate.use(locale);
            this.$state.reload();
        }

        addPart(name: string) {
            this.$translatePartialLoader.addPart(name);
            this.$translate.refresh();
        }

        clearLanguage() {
            this.$cookies.remove('NG_TRANSLATE_LANG_KEY');
        }



        // PRIVATE 
        private getKendoTranslations(): ng.IPromise<{}> {
            return this.$translate([
                    'Core.Kendo.Contains',
                    'Core.Kendo.StartsWith',
                    'Core.Kendo.DoesNotContain',
                    'Core.Kendo.Eq',
                    'Core.Kendo.DateLe',
                    'Core.Kendo.DateGe',
                    'Core.Kendo.Gt',
                    'Core.Kendo.Lt',
                    'Core.Kendo.Neq',
                ])
                .then(trans => {
                    this.kendoFilterTranslation = new KendoFilterTranslation();
                    this.kendoFilterTranslation.Contains = trans['Core.Kendo.Contains'];
                    this.kendoFilterTranslation.StartsWith = trans['Core.Kendo.StartsWith'];
                    this.kendoFilterTranslation.DoesNotContain = trans['Core.Kendo.DoesNotContain'];
                    this.kendoFilterTranslation.Eq = trans['Core.Kendo.Eq'];
                    this.kendoFilterTranslation.DateLe = trans['Core.Kendo.DateLe'];
                    this.kendoFilterTranslation.DateGe = trans['Core.Kendo.DateGe'];
                    this.kendoFilterTranslation.Gt = trans['Core.Kendo.Gt'];
                    this.kendoFilterTranslation.Lt = trans['Core.Kendo.Lt'];
                    this.kendoFilterTranslation.Neq = trans['Core.Kendo.Neq'];

                    return this.kendoFilterTranslation;
                });
        }

        private selectKendoLocale(requested: string): string {
            var kendoLocale = 'en-US';
            if (requested && requested.indexOf('de') === 0) kendoLocale = 'de-DE';

            return kendoLocale;
        }

        private selectMomentLocale(requested: string): string {
            // en basic is default, so call no method needed!
            var ret = 'en';
            if (requested && requested.indexOf('de') === 0) ret = 'de';
            return ret;
        }

        private selectAngularLocale(requested: string): string {
            var ret = "en";
            if (requested && requested.indexOf('de') === 0) ret = 'de';
            return ret;
        }



        // OTHER



        init() {
            // Locales to Check:
            // 1. angular-translate: dynamically set
            // 2. moment: dynamically set
            // 3. angular: dynamically set per extention
            // 4. kendo

            var deferred = this.$q.defer();

            // 1. angular-translate (from browsersetting or from cookie) or override from server (user language setting)
            var locale = this.getLocale();
            var cookie = this.$cookies.get('NG_TRANSLATE_LANG_KEY');
            if (cookie && cookie.length >= 3) {
                var cookieValue = cookie.substring(1, 3);
                if (cookieValue && cookieValue !== locale) {
                    this.$translate.use(cookieValue);
                    locale = cookieValue;
                }
            }
            
            // 2. moment
            var momentLocale = this.selectMomentLocale(locale);
            if (momentLocale) moment.locale(momentLocale);

            // 3. kendo load manual translations & calc language code
            this.getKendoTranslations();
            var kendoLocale = this.selectKendoLocale(locale);


            if (kendo.culture().name === kendoLocale) {
                deferred.resolve();
            } else {
                // 4. angular
                var angularLocale = this.selectAngularLocale(locale);
                this.tmhDynamicLocale.set(angularLocale)
                    .then(() => {
                        // 5. kendo
                        $.getScript("/Scripts/kendo.messages." + kendoLocale + ".min.js",
                            () => {
                                kendo.culture(kendoLocale);
                                console.info("Selected Locale: angular=" + angularLocale + " angular-translate=" + locale + " kendo=" + kendoLocale + " moment=" + momentLocale);
                                deferred.resolve();
                            });
                    });
            }

            return deferred.promise;
        }


    }
angular.module("app").factory('localeService', ['$q', '$translate', '$translatePartialLoader', '$state', 'tmhDynamicLocale', '$cookies', LocaleService.Factory]);
}

